export { default } from "./MainSearch";
